<template>
  <input
    class="form-control"
    type="text"
    :name="id"
    :id="id"
    :required="field.specification.required"
    v-model="content"
    @keyup="handleUpdate"
  />
</template>

<script>
  export default {
    props: ['id', 'field'],

    components: {
      //
    },

    data() {
      return {
        content: this.field.value,
      };
    },

    methods: {
      handleUpdate(event) {
        this.$emit('field-update', this.field.key, event.currentTarget.value);
      },
    },
  };
</script>
